import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_82: FaireProductEntity = {
  token: "catalog_prod_prod-82",
  type: "product",
  name: "Figurine",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 42.63,
  msrpDollars: 106.58,
  sku: "AN0082",
  caseSize: 1,
  material: "Ceramic",
  collectionToken: "col_andean-touch",
  categoryTokens: ["catalog_cat_dogs"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 201,
  description: "Beautiful Andean Touch piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
